module.exports = __webpack_public_path__ + "img/wscgq0.b03c009a.png";